import { ListingCard } from '@/components/listing-card';
import { type ListingCardProps } from '@/types';
import React from 'react';

interface ListingResultsGridProps {
    listings: ListingCardProps[];
    onFavorite?: (listingId: number) => void;
    onViewProfile?: (listingId: number) => void;
}

export const ListingResultsGrid: React.FC<ListingResultsGridProps> = ({ listings, onFavorite, onViewProfile }) => {
    if (listings.length === 0) {
        return (
            <div className="flex min-h-[400px] items-center justify-center rounded-lg bg-white p-8 text-center">
                <div className="space-y-3">
                    <div className="text-6xl">🔍</div>
                    <h3 className="text-xl font-semibold text-gray-900">Nenhuma empresa encontrada</h3>
                    <p className="text-gray-600">Tente ajustar seus filtros ou fazer uma nova pesquisa.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-5">
            {listings.map((listing) => (
                <ListingCard
                    key={listing.id}
                    {...listing}
                    onFavorite={() => onFavorite?.(listing.id)}
                    onViewProfile={() => onViewProfile?.(listing.id)}
                />
            ))}
        </div>
    );
};
